import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { TokenStore } from '@app/core/auth/token-store';

const apiBaseUrl = environment.api.url.replace(/\/+$/, '');

/**
 * Attaches `Authorization: Bearer <token>` to requests aimed at the GogoKids API
 * (and nothing else, so asset/i18n requests stay clean).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(TokenStore).accessToken();
  if (!token || !req.url.startsWith(apiBaseUrl) || req.headers.has('Authorization')) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
